// extracted by mini-css-extract-plugin
export default {"detail":"DetailText_detail__Ug0qp","category":"DetailText_category__v2Njo","text":"DetailText_text__aa6vZ"};